var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSetaPolygona = function SvgSetaPolygona(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 30,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.498 16.441a2 2 0 0 1 0-2.882L14.613.939C15.883-.285 18 .615 18 2.378v25.242c0 1.763-2.116 2.663-3.387 1.44z"
  })));
};
export default SvgSetaPolygona;